import React, { useEffect, useRef, useState } from "react";
import cn from "classnames";
import { Route, Switch, useLocation } from "react-router-dom";
import {
  MAIN_LAYOUT_LOADING,
  SMTP_SYNC_LOADING,
} from "../../constants/loading.constant";
import {
  CHANGE_SUBSCRIPTION_MODAL,
  ME_USER_EDIT_FORM,
  SMTP_ME_BIND_MODAL,
} from "../../constants/modal.constant";
import { useGlobalCore } from "../../cores/globals";
import { useMeCore } from "../../cores/me";
import { useRouterCore } from "../../cores/router";
import ProtectedRoute from "../component/companies/ProtectedRoute";
import { LoadingSpinnerWembii } from "../component/LoadingSpinnerWembii";
import NavBar from "../component/navBar/NavBar";
import NoConfirmedModal from "../component/NoConfirmedModal";
import GooglePopUp from "../component/social/GoogleAnalitycs/GooglePopUp";
import JumpsellerPopUp from "../component/social/Jumpseller/JumpsellerPopUp";
import MailchimpPopUp from "../component/social/Mailchimp/MailchimpPopUp";
import LinkedInPopUp from "../component/social/LinkedIn/LinkedInPopUp";
import MercadolibrePopUp from "../component/social/Mercadolibre/MercadolibrePopUp";
import TwitterPopUp from "../component/social/Twitter/TwitterPopUp";
import WooCommercePopUp from "../component/social/WooCommerce/WooCommercePopUp";
import { ActivityBoardsScreen } from "../screen/ActivityBoards";
import { BusinessBoardScreen } from "../screen/BusinessBoard";
import { BusinessBoardAnalyticsScreen } from "../screen/BusinessBoardAnalytics";
import Companies from "../screen/Companies";
import { ContactsScreen } from "../screen/Contacts";
import CreateCampaign from "../screen/CreateCampaign";
import ActivityBoard from "../screen/ActivityBoard";
import EditCompany from "../screen/EditCompany";
import EditWebChat from "../screen/EditWebChat";
import EditWebForm from "../screen/EditWebForm";
import EditWhatsappChat from "../screen/EditWhatsappChat";
import { FacebookAnalytics } from "../screen/FacebookAnalytics";
import { SummaryAnalytics } from "../screen/SummaryAnalytics";
import FacebookCampaigns from "../screen/FacebookCampaigns";
import FacebookForms from "../screen/FacebookForms";
import { GoogleAnalytics } from "../screen/GoogleAnalytics";
import { InstagramAnalytics } from "../screen/InstagramAnalytics";
import { TikTokAnalytics } from "../screen/TikTokAnalytics";
import { LinkedInBusinessAnalytics } from "../screen/LinkedInBusinessAnalytics";
import { YouTubeAnalytics } from "../screen/YouTubeAnalytics";
import { JumpsellerMarket } from "../screen/JumpsellerMarket";
import MeCompanies from "../screen/MeCompanies";
import { MercadolibreAnalytics } from "../screen/MercadolibreAnalytics";
import { MercadolibreMarket } from "../screen/MercadolibreMarket";
import { ReportsScreen } from "../screen/Reports";
import Resellers from "../screen/Reseller";
import Social from "../screen/Social";
import SocialCalendar from "../screen/SocialCalendar";
import SocialContentGrid from "../screen/SocialContentGrid";
import SocialHistory from "../screen/SocialHistory";
import SocialStreams from "../screen/SocialStreams";
import SocialManager from "../screen/SocialManager";
import SocialPost from "../screen/SocialPost";
import SocialAutomatedPosts from "../screen/SocialAutomatedPosts";
import AIGeneration from "../screen/AIGeneration";
import TextToImage from "../screen/TextToImage";
import Users from "../screen/Users";
import WembiiAdminDashboard from "../screen/WembiiAdminDashboard";
import WembiiAdminSupport from "../screen/WembiiAdminSupport";
import WembiiAdminSendGridBilling from "../screen/WembiiAdminSendGridBilling";
import ViewFacebookForm from "../screen/ViewFacebookForm";
import WebChat from "../screen/WebChat";
import WebForms from "../screen/WebForms";
import WebsitePages from "../screen/WebsitePages";
import EditWebsitePage from "../screen/EditWebsitePage";
import {
  EmailMarketingEmailsScreen,
  EmailMarketingListsScreen,
  EmailMarketingReportsScreen,
} from "../screen/emailMarketing/EmailMarketingPlaceholder";
import { EmailMarketingConfigScreen } from "../screen/emailMarketing/EmailMarketingConfigScreen";
import { EmailMarketingCampaignDetailScreen } from "../screen/emailMarketing/EmailMarketingCampaignDetailScreen";
import { EmailMarketingTemplatesScreen } from "../screen/emailMarketing/EmailMarketingTemplatesScreen";
import { WooCommerceAnalytics } from "../screen/WooCommerceAnalytics";
import { WooCommerceMarket } from "../screen/WooCommerceMarket";
import SideModal from "./SideModal";
import { TasksScreen } from "../screen/Tasks";
import GmailPopUp from "../component/social/Gmail/GmailPopUp";
import GoogleCalendarPopUp from "../component/social/GoogleCalendar/GoogleCalendarPopUp";
import GoogleDrivePopUp from "../component/social/GoogleDrive/GoogleDrivePopUp";
import SocialStory from "../screen/SocialStory";
import { ContactCompaniesScreen } from "../screen/ContactCompanies";
import { AutomationsScreen } from "../screen/Automations";
import { CalendarScreen } from "../screen/Calendar";
import TemporalPasswordModal from "../component/TemporalPasswordModal";
import { Plans } from "../screen/Plans";
import Office365PopUp1 from "../component/social/Office365/Office365PopUp1";
import Office365PopUp2 from "../component/social/Office365/Office365PopUp2";
import Sidebar from "../component/sideBar/SideBar";
import Notifications from "../screen/Notifications";
import Home from "../screen/Home";
import HomeDashboard from "../screen/HomeDashboard";
import TiktokPopUp from "../component/social/Tiktok/TiktokPopUp";
import InstagramLoginPopUp from "../component/social/InstagramLogin/InstagramLoginPopUp";
import YoutubePopUp from "../component/social/Youtube/YoutubePopUp";
import VideoGen from "../screen/VideoGen";
import VideoEditor from "../screen/VideoEditor";
import { DarkModePromptOverlay } from "./DarkModePromptOverlay";
export default function MainLayout() {
  const location = useLocation();
  const { routes } = useRouterCore();
  const { company, user, isAdmin } = useMeCore();
  const {
    isModal,
    turnOffModal,
    getModalContent,
    getModalVisibility,
    turnOffLoading,
    openSideBar,
    setOpenSideBar,
    collapseSideBar,
    isDarkMode,
    setDarkMode,
  } = useGlobalCore();

  const DARK_MODE_PROMPT_NO_AGAIN_KEY = "wembii_dark_mode_prompt_no_again";
  const [darkModePromptOpen, setDarkModePromptOpen] = useState(false);
  const [dontShowAgain, setDontShowAgain] = useState(false);
  const didPromptThisSessionRef = useRef(false);

  useEffect(() => {
    document.body.classList.toggle("dark-mode", isDarkMode);
    localStorage.setItem("wembii_dark_mode", String(isDarkMode));
  }, [isDarkMode]);

  // Show a one-time prompt after login (when user enters MainLayout).
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (isDarkMode) return;
    if (!user?.id) return;
    if (!user?.verified) return;
    if (user?.temporalPassword) return;
    if (didPromptThisSessionRef.current) return;

    didPromptThisSessionRef.current = true;
    try {
      const noAgain =
        window.localStorage.getItem(DARK_MODE_PROMPT_NO_AGAIN_KEY) === "true";
      if (!noAgain) setDarkModePromptOpen(true);
    } catch {
      setDarkModePromptOpen(true);
    }
  }, [isDarkMode, user?.id, user?.verified, user?.temporalPassword]);

  useEffect(() => {
    if (darkModePromptOpen) setDontShowAgain(false);
  }, [darkModePromptOpen]);

  const closePrompt = (nextDarkMode?: boolean) => {
    if (typeof window === "undefined") return;
    if (dontShowAgain) {
      window.localStorage.setItem(DARK_MODE_PROMPT_NO_AGAIN_KEY, "true");
    }
    if (typeof nextDarkMode === "boolean") setDarkMode(nextDarkMode);
    setDarkModePromptOpen(false);
  };

  useEffect(() => {
    if (typeof window === "undefined") return;
    const mq = window.matchMedia("(max-width: 991.98px)");
    const syncBodyScrollLock = () => {
      if (openSideBar && mq.matches) {
        document.body.classList.add("sidebar-mobile-scroll-lock");
      } else {
        document.body.classList.remove("sidebar-mobile-scroll-lock");
      }
    };
    syncBodyScrollLock();
    mq.addEventListener("change", syncBodyScrollLock);
    return () => {
      mq.removeEventListener("change", syncBodyScrollLock);
      document.body.classList.remove("sidebar-mobile-scroll-lock");
    };
  }, [openSideBar]);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!window.matchMedia("(max-width: 991.98px)").matches) return;
    setOpenSideBar(false);
  }, [location.pathname, setOpenSideBar]);

  const isWebChatRoute = location.pathname === routes.webChat;
  const isWebsiteEditorRoute = /^\/website\/pages\/[^/]+$/.test(location.pathname);
  const isWembiiAdminSupportRoute = location.pathname === routes.wembiiAdminSupport;
  const isFullBleedRoute =
    isWebChatRoute || isWebsiteEditorRoute || isWembiiAdminSupportRoute;

  return (
    <div className="d-flex h-100 w-100 main-layout-root">
      <div
        className={cn(
          "sidebar sidebar-main-wrap p-3 d-none d-lg-block overflow-hidden",
          {
            "d-flex flex-column position-relative d-lg-block sidebar-main-wrap--open":
              openSideBar,
            "sidebar-main-wrap--collapsed": collapseSideBar,
            "sidebar-main-wrap--expanded": !collapseSideBar,
            "d-lg-none": isWebsiteEditorRoute,
          }
        )}
      >
        <Sidebar />
      </div>
      <div
        className={cn("p-md-3 pt-3", {
          mainSection: !openSideBar,
          mainSectionCollaped: collapseSideBar,
          mainSectionExpanded: !collapseSideBar,
          "layout-webchat-fill": isFullBleedRoute,
          "layout-website-editor-fill": isWebsiteEditorRoute,
          "p-0 pt-0": isWebsiteEditorRoute,
        })}
      >
        <div className={cn("mb-1", { "d-none": isWebsiteEditorRoute })}>
          <NavBar />
        </div>
        <LoadingSpinnerWembii
          size="lg"
          id={MAIN_LAYOUT_LOADING}
          style={{ top: "40%" }}
        >
          <div
            className={cn("main-layout-content-scroll", {
              "pb-5": !isFullBleedRoute,
              "pb-0 pt-0 main-layout-webchat-scroll main-layout-content-scroll--full":
                isFullBleedRoute,
            })}
          >
            <Switch>
              <Route path={routes.users} component={Users} />
              <Route path={routes.notifications} component={Notifications} />
              <ProtectedRoute
                exact
                path={routes.wembiiAdminDashboard}
                component={WembiiAdminDashboard}
                open={Boolean(isAdmin)}
              />
              <ProtectedRoute
                exact
                path={routes.wembiiAdminSupport}
                component={WembiiAdminSupport}
                open={Boolean(isAdmin)}
              />
              <ProtectedRoute
                exact
                path={routes.wembiiAdminSendGridBilling}
                component={WembiiAdminSendGridBilling}
                open={Boolean(isAdmin)}
              />
              <Route exact path={routes.company} component={Companies} />
              <Route exact path={routes.meCompany} component={MeCompanies} />
              <Route path={routes.editCompany} component={EditCompany} />
              <Route path={routes.plans} component={Plans} />
              <ProtectedRoute
                exact
                path={routes.webForms}
                component={WebForms}
                open={Boolean(company?.id)}
              />
              <ProtectedRoute
                exact
                path={routes.editWebForm}
                component={EditWebForm}
                open={Boolean(company?.id)}
              />
              <ProtectedRoute
                exact
                path={routes.websitePages}
                component={WebsitePages}
                open={Boolean(company?.id)}
              />
              <ProtectedRoute
                exact
                path={routes.editWebsitePage}
                component={EditWebsitePage}
                open={Boolean(company?.id)}
              />
              <ProtectedRoute
                exact
                path={routes.emailMarketingLists}
                component={EmailMarketingListsScreen}
                open={Boolean(isAdmin && company?.id)}
              />
              <ProtectedRoute
                exact
                path={routes.emailMarketingEmails}
                component={EmailMarketingEmailsScreen}
                open={Boolean(isAdmin && company?.id)}
              />
              <ProtectedRoute
                exact
                path={routes.emailMarketingCampaignDetail}
                component={EmailMarketingCampaignDetailScreen}
                open={Boolean(isAdmin && company?.id)}
              />
              <ProtectedRoute
                exact
                path={routes.emailMarketingTemplates}
                component={EmailMarketingTemplatesScreen}
                open={Boolean(isAdmin && company?.id)}
              />
              <ProtectedRoute
                exact
                path={routes.emailMarketingReports}
                component={EmailMarketingReportsScreen}
                open={Boolean(isAdmin && company?.id)}
              />
              <ProtectedRoute
                exact
                path={routes.emailMarketingConfig}
                component={EmailMarketingConfigScreen}
                open={Boolean(isAdmin && company?.id)}
              />
              <ProtectedRoute
                exact
                path={routes.facebookForm}
                component={FacebookForms}
                open={Boolean(company?.id)}
              />
              <ProtectedRoute
                exact
                path={routes.viewFacebookForm}
                component={ViewFacebookForm}
                open={Boolean(company?.id)}
              />
              <ProtectedRoute
                exact
                path={routes.webChat}
                component={WebChat}
                open={Boolean(company?.id)}
              />
              <ProtectedRoute
                exact
                path={routes.editWebChat}
                component={EditWebChat}
                open={Boolean(company?.id)}
              />
              <ProtectedRoute
                exact
                path={routes.editWhatsappChat}
                component={EditWhatsappChat}
                open={Boolean(company?.id)}
              />
              <ProtectedRoute
                exact
                path={routes.activityBoards}
                component={ActivityBoardsScreen}
                open={Boolean(company?.id)}
              />
              <ProtectedRoute
                exact
                path={routes.businessBoard}
                component={BusinessBoardScreen}
                open={Boolean(company?.id)}
              />
              <ProtectedRoute
                exact
                path={routes.tasks}
                component={TasksScreen}
                open={Boolean(company?.id)}
              />
              <ProtectedRoute
                exact
                path={routes.businessBoardAnalytics}
                component={BusinessBoardAnalyticsScreen}
                open={Boolean(company?.id)}
              />
              <ProtectedRoute
                exact
                path={routes.editBoards}
                component={ActivityBoard}
                open={Boolean(company?.id)}
              />
              <ProtectedRoute
                exact
                path={routes.calendar}
                component={CalendarScreen}
                open={Boolean(company?.id)}
              />
              <ProtectedRoute
                exact
                path={routes.facebookCampaigns}
                component={FacebookCampaigns}
                open={Boolean(company?.id)}
              />
              <ProtectedRoute
                exact
                path={routes.createCampaign}
                component={CreateCampaign}
                open={Boolean(company?.id)}
              />
              <ProtectedRoute
                exact
                path={routes.social}
                component={Home}
                open={Boolean(company?.id)}
              />
              <ProtectedRoute
                exact
                path={routes.homeDashboard}
                component={HomeDashboard}
                open={Boolean(company?.id)}
              />
              <ProtectedRoute
                exact
                path={routes.binding}
                component={Social}
                open={Boolean(company?.id)}
              />
              <ProtectedRoute
                path={routes.socialStory}
                component={SocialStory}
                open={Boolean(company?.id)}
              />
              <ProtectedRoute
                path={routes.socialPost}
                component={SocialPost}
                open={Boolean(company?.id)}
              />
              <ProtectedRoute
                exact
                path={routes.socialAutomatedPosts}
                component={SocialAutomatedPosts}
                open={Boolean(company?.id)}
              />
              <ProtectedRoute
                exact
                path={routes.aiGeneration}
                component={AIGeneration}
                open={Boolean(company?.id)}
              />
              <ProtectedRoute
                exact
                path={routes.aiTextToImage}
                component={TextToImage}
                open={Boolean(company?.id)}
              />
              <ProtectedRoute
                exact
                path={routes.socialStreams}
                component={SocialStreams}
                open={Boolean(company?.id)}
              />
              <ProtectedRoute
                exact
                path={routes.socialHistory}
                component={SocialHistory}
                open={Boolean(company?.id)}
              />
              <ProtectedRoute
                exact
                path={routes.socialManager}
                component={SocialManager}
                open={isAdmin}
              />
              <ProtectedRoute
                exact
                path={routes.socialContentGrid}
                component={SocialContentGrid}
                open={Boolean(company?.id)}
              />
              <ProtectedRoute
                exact
                path={routes.socialCalendar}
                component={SocialCalendar}
                open={Boolean(company?.id)}
              />
              <ProtectedRoute
                exact
                path={routes.videoGen}
                component={VideoGen}
                open={Boolean(company?.id)}
              />
              <ProtectedRoute
                exact
                path={routes.videoEditor}
                component={VideoEditor}
                open={Boolean(company?.id)}
              />
              <Route path={routes.linkedInPopUp} component={LinkedInPopUp} />
              <Route path={routes.twitterPopUp} component={TwitterPopUp} />
              <Route path={routes.tiktokPopUp} component={TiktokPopUp} />
              <Route
                path={routes.instagramLoginPopUp}
                component={InstagramLoginPopUp}
              />
              <Route path={routes.youtubePopUp} component={YoutubePopUp} />
              <Route
                path={routes.analyticsSummary}
                component={SummaryAnalytics}
              />
              <Route
                path={routes.facebookAnalytics}
                component={FacebookAnalytics}
              />
              <Route
                path={routes.wooCommerceAnalytics}
                component={WooCommerceAnalytics}
              />
              <Route
                path={routes.instagramAnalytics}
                component={InstagramAnalytics}
              />
              <Route
                path={routes.tiktokAnalytics}
                component={TikTokAnalytics}
              />
              <Route
                path={routes.linkedinBusinessAnalytics}
                component={LinkedInBusinessAnalytics}
              />
              <Route
                path={routes.youtubeAnalytics}
                component={YouTubeAnalytics}
              />
              <Route
                path={routes.googleAnalytics}
                component={GoogleAnalytics}
              />
              <Route
                exact
                path={routes.googleCalendarPopUp}
                component={GoogleCalendarPopUp}
              />
              <Route
                exact
                path={routes.googleDrivePopUp}
                component={GoogleDrivePopUp}
              />
              <Route exact path={routes.googlePopUp} component={GooglePopUp} />
              <Route path={routes.gmailPopUp} component={GmailPopUp} />
              <Route
                exact
                path={routes.office365PopUp1}
                component={Office365PopUp1}
              />
              <Route
                exact
                path={routes.office365PopUp2}
                component={Office365PopUp2}
              />
              <Route
                path={routes.jumpsellerPopUp}
                component={JumpsellerPopUp}
              />
              <Route path={routes.mailchimpPopUp} component={MailchimpPopUp} />
              <Route path={routes.wooPopUp} component={WooCommercePopUp} />
              <Route
                path={routes.mercadolibrePopUp}
                component={MercadolibrePopUp}
              />
              <Route
                path={routes.wooCommerceOrders}
                component={WooCommerceMarket}
              />
              <Route
                path={routes.mercadolibreOrders}
                component={MercadolibreMarket}
              />
              <Route
                path={routes.mercadolibreAnalytics}
                component={MercadolibreAnalytics}
              />
              <Route
                path={routes.jumpsellerOrders}
                component={JumpsellerMarket}
              />
              <Route path={routes.contacts} component={ContactsScreen} />
              <Route
                exact
                path={routes.contactCompanies}
                component={ContactCompaniesScreen}
              />
              <Route exact path={routes.reports} component={ReportsScreen} />
              <Route path={routes.resellers} component={Resellers} />
              <Route path={routes.automations} component={AutomationsScreen} />
            </Switch>
          </div>
        </LoadingSpinnerWembii>

        <DarkModePromptOverlay
          isOpen={darkModePromptOpen}
          dontShowAgain={dontShowAgain}
          onDontShowAgainChange={setDontShowAgain}
          onLater={() => closePrompt(false)}
          onEnable={() => closePrompt(true)}
        />

        <SideModal
          active={isModal(CHANGE_SUBSCRIPTION_MODAL)}
          visible={getModalVisibility(CHANGE_SUBSCRIPTION_MODAL)}
          onClose={() => turnOffModal(CHANGE_SUBSCRIPTION_MODAL)}
        >
          {getModalContent(CHANGE_SUBSCRIPTION_MODAL)}
        </SideModal>
        <SideModal
          active={isModal(ME_USER_EDIT_FORM)}
          visible={getModalVisibility(ME_USER_EDIT_FORM)}
          onClose={() => turnOffModal(ME_USER_EDIT_FORM)}
        >
          {getModalContent(ME_USER_EDIT_FORM)}
        </SideModal>
        <SideModal
          active={isModal(SMTP_ME_BIND_MODAL)}
          visible={getModalVisibility(SMTP_ME_BIND_MODAL)}
          onClose={() => {
            turnOffModal(SMTP_ME_BIND_MODAL);
            turnOffLoading(SMTP_SYNC_LOADING);
          }}
          left
        >
          {getModalContent(SMTP_ME_BIND_MODAL)}
        </SideModal>
      </div>
      {user && !user.verified && <NoConfirmedModal />}
      {user && user.verified && user.temporalPassword && (
        <TemporalPasswordModal />
      )}
    </div>
  );
}
